import { useMutation, useQueryClient } from "@tanstack/react-query";
import queryKeys from "../constants/queryKeys";
import documentService from "../services/documentService";

const useDeleteAccountFile = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: ({ formData, documentType }) =>
            documentService.deleteAccountFile(formData, documentType),
        onSuccess: () =>
            queryClient.invalidateQueries({ queryKey: [queryKeys.accountFiles] }),
    });
};

export default useDeleteAccountFile;
